export default __webpack_public_path__ + "static/media/close.fd669b57.svg";